import Geolocation, {GeoPosition} from 'react-native-geolocation-service';
import {Platform} from 'react-native';

export const getCurrentPosition = async (): Promise<GeoPosition> => {
  if (Platform.OS === 'ios') {
    const requestAuthorizationResult = await Geolocation.requestAuthorization('whenInUse');

    if (requestAuthorizationResult !== 'granted') {
      throw new Error('No access to geolocation');
    }
  }

  return new Promise((resolve, reject) => Geolocation.getCurrentPosition(resolve, reject));
};

/*
export const getCurrentPosition = (): Promise<GeoPosition> => {
  return new Promise((resolve, reject) => {
    if (Platform.OS === 'ios') {
      Geolocation.requestAuthorization('whenInUse')
        .then((result) => {
          if (result === 'granted') {
            resolve();
          } else reject(result);
        })
        .catch(reject);
    } else resolve();
  }).then(() => {
    return new Promise((resolve, reject) => Geolocation.getCurrentPosition(resolve, reject));
  });
};
*/
